import React from 'react';

const LandingPage = () => {
  return (
    <div className="relative w-full h-screen">
      {/* Background Video */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute top-0 left-0 w-full h-full object-cover"
      >
        <source src="/background-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-50"></div>

      {/* Centered Content */}
      <div className="absolute inset-0 flex flex-col justify-center items-center text-center text-white px-4">
        {/* Logo or Image */}
        <div className="mb-6">
          <img
            src="/transparent.png"
            alt="BJELUTAK"
            className="max-w-[300px] mx-auto"
          />
        </div>

        {/* Headline and Text */}
        <div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">
            Do you need a new home built? Contact us today.
          </h2>
          <p className="text-lg sm:text-xl mb-8">
            Your dream home can be a reality.
            <br />
            Let us help you make it happen.
          </p>

          {/* Call-to-Action Button */}
          <a href="/contact">
            <button className="px-6 py-3 bg-white text-black font-semibold rounded-lg shadow-lg hover:bg-black hover:text-white transition">
              Contact Us
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
